module.exports = __webpack_public_path__ + "static/media/PushtimargImage32.6373f1a1.jpg";